import { BFormDatepicker } from "bootstrap-vue";
import { createEgBootstrapProxy } from "../createEgBootstrapProxy";

export const EgBFormDatepicker = createEgBootstrapProxy(
  "EgBFormDatepicker",
  BFormDatepicker
);
